import { render, staticRenderFns } from "./type_activity_4.vue?vue&type=template&id=4704b28a"
import script from "./type_activity_4.vue?vue&type=script&lang=js"
export * from "./type_activity_4.vue?vue&type=script&lang=js"
import style0 from "./type_activity_4.vue?vue&type=style&index=0&id=4704b28a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports